/* eslint-disable */
import VueStoreService from './VueStoreService';

const FinancialMovementService = {
  async uploadExcel(data, store) {
    return await VueStoreService.postFile('uploads', data, store)
  },

  async getUploads(store) {
    return await VueStoreService.get('uploads', store)
  },

  async getSummary(params, store) {
    const query = []
    if (params.companyIds?.length === 1) query.push(`companyId=${params.companyIds[0]}`)
    if (params.from) query.push(`from=${params.from}`)
    if (params.to) query.push(`to=${params.to}`)
    if (params.currency) query.push(`currency=${params.currency}`)
    const url = `transactions/summary${query.length ? '?' + query.join('&') : ''}`
    return await VueStoreService.get(url, store)
  },

  async deleteUpload(id, store) {
  return await VueStoreService.delete(`uploads/${id}`, store);
}
};

export default FinancialMovementService;
